/**
 * Extracts the cursor parameter from a Django REST Framework paginated response's next URL.
 *
 * Django REST pagination typically returns a structure like:
 * ```json
 * {
 *   "next": "https://api.example.com/endpoint?cursor=xyz",
 *   "previous": "...",
 *   "results": [...]
 * }
 * ```
 *
 * This helper extracts the cursor value from the `next` URL to use with `listAllPaginatedRest`.
 *
 * @param result - The API response containing a potential next URL
 * @returns The cursor string to use for the next page, or empty string if none
 *
 * @example
 * ```ts
 * const response = await apiCall()
 * const nextCursor = getCursorFromNextURL(response)
 * // Use with listAllPaginatedRest to paginate through all results
 * ```
 */
export function getCursorFromNextURL(result) {
    var _a;
    if ((_a = result.data) === null || _a === void 0 ? void 0 : _a.next) {
        const url = new URL(result.data.next);
        return url.searchParams.get('cursor') || '';
    }
    return '';
}
